import utils from '../../../utils/utils.js';

export default {
  async fetchWorkspaceUsers(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetWorkspaceUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      'GET',
      null,
      null
    );
    context.commit('setWorkspaceUsers', responseData.data);
  },
  async fetchWorkspaceUserGroups(context, payload) {
    const ntUserName = payload.ntUserName;
    const response = await utils.utility.fetch(
      `api/Setting/GetUserGroups?ntUserName=${ntUserName}`,
      'GET',
      null,
      null
    );

    context.commit('setWorkspaceUserGroups', response.data);
  },
  async postWorkspaceUser(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateWorkspaceUser`,
      'POST',
      null,
      payload
    );
  },
  async putWorkspaceUser(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateWorkspaceUser`,
      'PUT',
      null,
      payload
    );
  },

  async deleteWorkspaceUser(context, payload) {
    let postData = { userId: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteWorkspaceUser`,
      'POST',
      null,
      postData
    );
  },
};
